import { useNavigate } from "react-router-dom";
import React, { useContext, useState, useEffect } from "react";
import { useForm } from "react-hook-form";
// import Image from 'react-bootstrap/Image';
import NotificationsAlert from "../../services/NotificationsAlert";
import { ClienteContext } from "../../services/ClienteContext";
import Conect from "../../../Api/Conect";

import "./styles.css";
import Logo from '../../assets/Logo.png'


const UserLogin = () => {

    const history = useNavigate();
    const { register, handleSubmit, } = useForm();
    const cliente = useContext(ClienteContext);
    const [email, setEmail] = useState()
    const [password, setPassword] = useState()

    useEffect(() => {
        verifyToken()
        // eslint-disable-next-line
    }, [])

    const verifyToken = async () => {

        let token = localStorage.getItem("restoken")

        if (token !== undefined) {
            const auth = await Conect.get(`/dmVyaWZ5YXV0aA==${token}`)
            if (auth.data.erro === "false") {
                NotificationsAlert("default", "", auth.data.msg)
                history("/gestoria");
            } else {
                // NotificationsAlert("warning", "Atenção", auth.data.msg)
                history("/sistema");
            }
        }
    };

    const onSubmit = async (data) => {

        const usuario = await Conect.post("/login", {
            email: data.email,
            pass: data.password
        })
        if (usuario.data.erro === true) {
            if (usuario.data.status === true) {
                NotificationsAlert("danger", "Atenção", usuario.data.msg)
            } else {
                NotificationsAlert("warning", "Atenção", usuario.data.msg)
            }
        }
        else {
            localStorage.setItem("resid", usuario.data.data.id)
            localStorage.setItem("resemail", usuario.data.data.email)
            localStorage.setItem("resfirstName", usuario.data.data.firstName)
            localStorage.setItem("reslastName", usuario.data.data.lastName)
            localStorage.setItem("resid_cli", usuario.data.data.id_cli)
            localStorage.setItem("resstateDescription", usuario.data.data.stateDescription)
            localStorage.setItem("resstateFuso", usuario.data.data.stateFuso)
            localStorage.setItem("resstatePrefix", usuario.data.data.statePrefix)
            localStorage.setItem("restoken", usuario.data.data.token)

            cliente.setDados({
                user_id: usuario.data.data.id,
                name: usuario.data.data.firstName,
                token: usuario.data.data.token,
                position: usuario.data.data.accessDescription,
                image: usuario.data.data.image,
                id_cli: usuario.data.data.id_cli
            });
            let message = `Olá! ${usuario.data.data.firstName}!`
            NotificationsAlert("default", message, "")
            history("/gestoria");
        }
    };

    return (
        <div className="container-login">
            <div className="wrap-login">
                <form className="login-form" onSubmit={handleSubmit(onSubmit)}>
                    <span className="login-form-title"> Bem vindo! </span>

                    <span className="login-form-title">
                        <img src={Logo} alt="Sakamotto Server Logo" />
                    </span>

                    <div className="wrap-input">
                        <input
                            className={email !== "" ? "has-val input" : "input"}
                            type="email"
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            {...register("email")}
                        />
                        <span className="focus-input" data-placeholder="Email"></span>
                    </div>

                    <div className="wrap-input">
                        <input
                            className={password !== "" ? "has-val input" : "input"}
                            type="password"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            {...register("password")}
                        />
                        <span className="focus-input" data-placeholder="Password"></span>
                    </div>

                    <div className="container-login-form-btn">
                        <button className="login-form-btn">Login</button>
                        <span className="txt1">Esqueceu sua senha? </span>
                        <button
                            className="txt2"
                            onClick={() => {
                                history("/escpass");
                            }}
                            style={{ background: "none", border: "none", color: "blue", textDecoration: "underline", cursor: "pointer" }}
                        >
                            Recuperar!
                        </button>
                    </div>

                </form>
            </div>
        </div>
    )

}

export default UserLogin;
